import React, { useEffect, useState } from 'react'
import Navbar3 from '../Navbars/Navbar3';
import axios from "axios";
import UserService from '../../services/UserService.js';
import getNotification from '../../Redux/Action/action';
import { useDispatch } from 'react-redux';
import { downloadPdf } from '../HelperFunction/helperFunction.js';
import maskedBrandOption from '../JSON Files/MaskedBrandOption.json'
const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;
const SavedReports = () => {
    const dispatch = useDispatch()
    const [reports, setReports] = useState([])
    const [isfetching, setIsfetching] = useState(false)

    const fetchReports = async () => {
        if (UserService.isLoggedIn()) {
            setIsfetching(true)
            try {
                const config = {
                    method: "get",
                    url: `${REACT_APP_UPLOAD_DATA}/app/getReports`,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                };

                const getResponse = await axios(config);
                setReports(getResponse?.data?.reports)
            }
            catch (err) {
                console.log("Server Error", err);
                if (err.response && err.response.status === 500) {
                    dispatch(
                        getNotification({
                            message: "Server is Down! Please try again after sometime",
                            type: "default",
                        })
                    );
                } else if (err.response && err.response.status === 400) {
                    dispatch(
                        getNotification({
                            message: "Input is not in prescribed format",
                            type: "default",
                        })
                    );
                } else if (err.response && err.response.status === 422) {
                    dispatch(
                        getNotification({
                            message: "Input is not in prescribed format",
                            type: "default",
                        })
                    );
                } else if (err.response && err.response.status === 404) {
                    dispatch(
                        getNotification({
                            message: "Page not Found",
                            type: "default",
                        })
                    );
                } else if (err.response && err.response.status === 401) {
                    dispatch(
                        getNotification({
                            message: "Session expired! Please log in again",
                            type: "default",
                        })
                    );
                }
            }
            finally {
                setIsfetching(false)
            }
        }
        else {
            setTimeout(() => {
                UserService.doLogin({
                    redirectUri: `${REACT_APP_REDIRECT_URI}/savedreports`,
                });
            }, 1000);
        }
    };
    const [selectedReportType, setSelectedReportType] = useState("");
    const [brandFilter, setBrandFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [isDownloading, setIsDownloading] = useState(false);

    const reportTypes = [
        "MarketAnalysis",
        "BrandAnalysis",
        "SimulatorReport",
        "OptimizerReport",
    ];

    const reportsPerPage = 12;

    // Filtered Reports based on report type and brand
    const filteredReports = reports.filter(
        (r) =>
            r.report_type.replace("_", "") === selectedReportType &&
            (!brandFilter || r.brand.toLowerCase() === brandFilter.toLowerCase())
    );

    // Pagination logic
    const indexOfLastReport = currentPage * reportsPerPage;
    const indexOfFirstReport = indexOfLastReport - reportsPerPage;
    const currentReports = filteredReports.slice(indexOfFirstReport, indexOfLastReport);
    const totalPages = Math.ceil(filteredReports.length / reportsPerPage);

    // Unique & sorted brands
    const brands = [
        ...new Set(
            reports
                .filter((r) => r.report_type.replace("_", "") === selectedReportType)
                .map((r) => r.brand)
        ),
    ].sort((a, b) => a.localeCompare(b));

    useEffect(() => {
        fetchReports();
    }, []);

    return (
        <>
            <Navbar3 />
            <div className="bgpages">
                <div className="mx-5 py-3">
                    {/* Breadcrumb */}
                    <div className="breadcrumb">Dashboard &gt;&gt; Saved Reports</div>

                    {/* Page Heading */}
                    <div
                        className="p-2  pageheading my-3 d-flex justify-content-between align-items-center"
                        style={{ fontSize: "20px" }}
                    >
                        <b>Saved Reports</b>
                    </div>

                    {/* No Reports Message */}
                    {
                        isfetching ?
                            <div className="my-3 d-flex flex-column align-items-center justify-content-center py-5" style={{ backgroundColor: "white" }}>
                                <div className="dot-loader">
                                    <div></div><div></div><div></div>
                                </div>
                                <div className="mt-2 fw-semibold text-muted">Grabbing Details...</div>
                            </div>
                            :
                            <>
                                {
                                    reports?.length === 0 ? (
                                        <div className="alert alert-warning text-center fw-semibold rounded-3 shadow-sm py-3">
                                            <i className="bi bi-exclamation-circle me-2"></i>
                                            No Reports found to display.
                                        </div>
                                    ) : (
                                        <>
                                            {/* Report Type Selector */}
                                            <div className="container-fluid">
                                                <div className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-light">
                                                    <div className="row align-items-center g-3">
                                                        <div className="col-12 col-md-4">
                                                            <label className="form-label fw-semibold mb-0">
                                                                <i className="bi bi-bar-chart-line text-primary me-2"></i>
                                                                Select Report Type:
                                                            </label>
                                                        </div>

                                                        <div className="col-12 col-md-8">
                                                            <select
                                                                className="form-select form-select-md shadow-sm border-0 rounded-3"
                                                                value={selectedReportType}
                                                                onChange={(e) => {
                                                                    setSelectedReportType(e.target.value);
                                                                    setBrandFilter("");
                                                                    setCurrentPage(1); // reset pagination
                                                                }}
                                                            >
                                                                <option value="">-- Choose Report Type --</option>
                                                                {reportTypes.map((type) => (
                                                                    <option key={type} value={type}>
                                                                        {type}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            {
                                                selectedReportType &&
                                                (
                                                    <div className='container-fluid'>
                                                        <div className="row">
                                                            {/* Filter Section */}
                                                            <div className="col-12 col-md-3 mb-4">
                                                                <div className="card shadow-sm p-3">
                                                                    <h5 className="card-title">Filters</h5>
                                                                    <div className="mb-3">
                                                                        <label className="form-label">Brand:</label>
                                                                        <select
                                                                            className="form-select"
                                                                            value={brandFilter}
                                                                            onChange={(e) => {
                                                                                setBrandFilter(e.target.value);
                                                                                setCurrentPage(1); // reset page when filter changes
                                                                            }}
                                                                        >
                                                                            <option value="">All Brands</option>
                                                                            {brands.map((brand) => (
                                                                                <option key={brand} value={brand}>
                                                                                    {brand}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Reports List Section */}
                                                            <div className="col-12 col-md-9">
                                                                <div className="row g-3">
                                                                    {currentReports.length === 0 ? (
                                                                        <div className="col-12">
                                                                            <div className="alert alert-info text-center">
                                                                                No reports match the selected filters.
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        currentReports.map((report) => (
                                                                            <div key={report.id} className="col-12 col-md-6 col-lg-4">
                                                                                <div className="card shadow-sm h-100">
                                                                                    <div className="card-body d-flex flex-column">
                                                                                        <h6 className="card-title fw-bold">
                                                                                            {report.brand}
                                                                                        </h6>
                                                                                        <p className="card-text text-muted small mb-3">
                                                                                            File Name: <strong>{report.pdf_name}</strong>
                                                                                        </p>
                                                                                        <p className="card-text text-muted small mb-2">
                                                                                            {report.report_type.replace("_", " ")}
                                                                                        </p>
                                                                                        <p className="card-text text-muted small mb-3">
                                                                                            Created: {report.created_at}
                                                                                        </p>
                                                                                        <button
                                                                                            disabled={isDownloading}
                                                                                            className="btn btn-primary mt-auto"
                                                                                            onClick={() => {
                                                                                                setIsDownloading(true);
                                                                                                downloadPdf(report.pdf_name, () => setIsDownloading(false));
                                                                                            }}
                                                                                        >
                                                                                            {isDownloading ? "Downloading..." : "Download Report"}
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    )}
                                                                </div>

                                                                {/* Pagination */}
                                                                {totalPages > 1 && (
                                                                    <nav className="mt-4">
                                                                        <ul className="pagination justify-content-center flex-wrap">
                                                                            <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                                                                                <button
                                                                                    className="page-link"
                                                                                    onClick={() => setCurrentPage(currentPage - 1)}
                                                                                >
                                                                                    Previous
                                                                                </button>
                                                                            </li>
                                                                            {[...Array(totalPages)].map((_, idx) => (
                                                                                <li
                                                                                    key={idx}
                                                                                    className={`page-item ${currentPage === idx + 1 && "active"}`}
                                                                                >
                                                                                    <button className="page-link" onClick={() => setCurrentPage(idx + 1)}>
                                                                                        {idx + 1}
                                                                                    </button>
                                                                                </li>
                                                                            ))}
                                                                            <li className={`page-item ${currentPage === totalPages && "disabled"}`}>
                                                                                <button
                                                                                    className="page-link"
                                                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                                                >
                                                                                    Next
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </nav>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </>
                                    )
                                }
                            </>
                    }
                </div>
            </div >
        </>
    );
}

export default SavedReports